import React from 'react';
import '../../pages/pages.css';
import aboutUsImg from './aboutUs.png';

function AboutUs() {
  return (
    <div className="page-container">
      <div className="page-image">
        <img src={aboutUsImg} />
      </div>
      <div className="page-text">
      <h1>About Us</h1>
        <p>
          Our founders, with their extensive experience in the collaboration space, recognized the need for innovative and user-friendly AV solutions.
        </p>
        <p>
          They formed <span className='bold-headers'>COLLABTECHNIQS CONSULTING PRIVATE LIMITED</span> to fill the gap with aspiring women flourishing in the AV and collaboration space, with a firm intention to add value with their experience and expertise.
        </p>
        <p className='bold-headers'>Our Values</p>
        <ul>
          <li>Empowerment of women in the AV & IT domains.</li>
          <li>Innovation in AV collaboration techniques with AI.</li>
          <li>Customer-Centric approach.</li>
          <li>Hassle-free collaboration solutions.</li>
          <li>Bridging gaps in the AV industry.</li>
        </ul>
      </div>
    </div>
  );
}

export default AboutUs;